export enum ErrorType {
  NOTFOUND = 'not-found',
  LINKEXPIRED = 'link-expired',
  CANNOTDOWNLOAD = 'cannot-download'
}

export enum ErrorCode {
  LINKEXPIRED = '101'
}
